import React, {useState} from 'react';
import {Alert, Button, Dropdown, Form, Input, Menu, Radio, Select, Space} from "antd";
import User from "./User";
import {observer} from "mobx-react";
import Logo from "./Logo";
import {DownOutlined} from "@ant-design/icons";
import axios from "axios";
import Device from "./Device";
import PlayerLogin, {LoginStore} from "./PlayerLogin";
import {callWithCatch} from "../utils";
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {NiceModalForm} from "./Modals";
import Birthdate from "./Birthdate";
import {DuprConnect} from "./DuprConnect";

let GhostBtn = ({u}) => {
  let click = async () => {
    await axios.get("/users/swap/" + u.id);
    location.reload();
  }

  return <Button onClick={click}>{u.name}</Button>;
}

const CreateChild = NiceModal.create(observer(({  }) => {
  const modal = useModal();

  let onSave = async (vals) => {
    await callWithCatch({
      url: '/users',
      params: { child: vals },
      method: 'post',
      reload: true
      // onSuccess: () => {
      //   location.href = troot + "/step/start_register";
      // }
    });
  }

  let parent = gon.user;

  return <NiceModalForm width={400} okText="Create Profile" onSave={onSave} modal={modal} title={"Create Child Profile"} initialValues={{lname: parent.lname, gender: "male"}}>
    <Alert description="Use this form to create a sub-account for your child under your account" />
    <br/>
    <Form.Item label="Parent Account">
      <Input disabled value={parent.name}/>
    </Form.Item>
    <div className="columns-2">
      <Form.Item name="fname" label="Child First Name" rules={[{required: true}]}>
        <Input autoFocus/>
      </Form.Item>
      <Form.Item name="lname" label="Child Last Name" rules={[{required: true}]}>
        <Input/>
      </Form.Item>
    </div>
    <Form.Item name="gender" label="Child Gender" rules={[{required: true}]}>
      <Radio.Group>
        <Radio value='male'>Male</Radio>
        <Radio value='female'>Female</Radio>
      </Radio.Group>
    </Form.Item>
    <Form.Item name="birthdate" label="Child Birthdate" rules={[{ required: true }]}>
      <Birthdate />
    </Form.Item>
  </NiceModalForm>
}));


export default observer(({hideLogin, dupr, links, ...props}) => {
  const [ghostUsers, setGhostUsers] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [ghostsLoaded, setGhostsLoaded] = useState(false);

  const [allUsers, setAllUsers] = useState([]);
  const [allLoading, setAllLoading] = useState(false);

  const onAllUsersSearch = (searchText) => {
    const q = (searchText || '').trim();
    if (q.length < 4) {
      setAllUsers([]);
      return;
    }
    callWithCatch({
      setLoading: setAllLoading,
      url: '/users/all',
      method: 'get',
      params: { q },
      onSuccess: data => setAllUsers(data.users)
    });
  };

  const loadGhosts = (q = '') => {
    callWithCatch({
      setLoading: setSearchLoading,
      url: '/users',
      method: 'get',
      params: { q, tid: gon.tournament.tid },
      onSuccess: data => setGhostUsers(data.users)
    });
  };

  const onGhostFocus = () => {
    if (!ghostsLoaded) {
      setGhostsLoaded(true);
      loadGhosts();
    }
  };

  const onGhostSearch = (searchText) => {
    loadGhosts(searchText || '');
  };

  let color = "rgb(62, 130, 247)";
  if (Device.dev)
    color = "#8b5cf6";

  let logout = () => {
    let logoutUrl = "/logout?back_to=" + location.href;

    location.href = logoutUrl;
  }

  const items = [
    { label: 'item 1', key: 'item-1' }, // remember to pass the key prop
    { label: 'item 2', key: 'item-2' }, // which is required
    {
      label: 'sub menu',
      key: 'submenu',
      children: [{ label: 'item 3', key: 'submenu-item-1' }],
    },
  ];

  let loginAs = u => {
    callWithCatch({
      url: "/users/swap/" + u.id,
      method: 'get',
      onSuccess: () => {
        location.reload();
      }
    })
  }

  let user = gon.user;

  if (dupr && user) {
    if (user.dupr_xid) {
      dupr = "DUPR ID: " + user.dupr_xid;
      dupr = <a onClick={() => DuprConnect.open(false)}>{dupr}</a>;
    }
    else
      dupr = <a onClick={() => DuprConnect.open(false)}>Connect DUPR</a>;
  }

  const menu = (
    <Menu mode="inline">
      <Menu.ItemGroup title="my account">
        <Menu.Item><a onClick={logout}>Logout</a></Menu.Item>
        { user && !user.parent && <Menu.Item><a onClick={() => LoginStore.open("change")}>Change Password</a></Menu.Item> }
        {gon.stripe === "connected" && <Menu.Item disabled>Stripe Connected</Menu.Item>}
        {gon.stripe && gon.stripe !== "connected" && gon.stripe !== "connect" && <Menu.Item><a href={gon.stripe}>Connect Stripe</a></Menu.Item>}
        {gon.stripe === "connect" && <Menu.Item><a href="/stripe/auth">Connect Stripe</a></Menu.Item>}
      </Menu.ItemGroup>
      {dupr && <Menu.ItemGroup title="rating">
        <Menu.Item>{dupr}</Menu.Item>
      </Menu.ItemGroup> }
      { user &&
        <Menu.ItemGroup title="other accounts">
          {user.parent && <Menu.Item><a className="text-sm" onClick={() => loginAs(gon.user.parent)}>{gon.user.parent.name}</a></Menu.Item>}
          {!user.parent && location.href.match(/tournaments/) && <Menu.Item><a onClick={() => NiceModal.show(CreateChild)}>Add a Child Account</a></Menu.Item> }
          {gon.user.children?.map(c => <Menu.Item key={c.id}><a className="text-sm" onClick={() => loginAs(c)}>{c.name}</a></Menu.Item>)}
        </Menu.ItemGroup> }
    </Menu>
  );

  return <div>
    {Device.local && !Device.xs && <Space>
      <GhostBtn u={{name: "Admin", id: 1}}/>
      <GhostBtn u={{name: "Test", id: 6}}/>
      <GhostBtn u={{name: "Y", id: 47964}}/>
      <Select style={{width: "200px"}}
              placeholder="Users"
              showSearch
              filterOption={false}
              onFocus={onGhostFocus}
              onSearch={onGhostSearch}
              loading={searchLoading}
              options={ghostUsers.map(u => ({value: u.id, label: u.name}))}
              onSelect={id => loginAs(ghostUsers.find(u => u.id === id))} />
      <Select style={{width: "200px"}}
              placeholder="All Users"
              showSearch
              filterOption={false}
              onSearch={onAllUsersSearch}
              notFoundContent={allLoading ? "Searching..." : "Type 4+ letters"}
              loading={allLoading}
              options={allUsers.map(u => ({value: u.id, label: u.name}))}
              onSelect={id => loginAs(allUsers.find(u => u.id === id))} />
      { gon.tournaments && <Select style={{width: "300px"}}
              placeholder="Tournaments"
              filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase())}
              options={gon.tournaments.map(t => ({value: t.tid, label: t.name}))}
              onSelect={tid => window.location.href = `/tournaments/${tid}`}
              showSearch/> }
    </Space>
    }

    <div style={{backgroundColor: color, padding: "0.5rem", color: 'white', fontSize: "13px"}}>
      <div style={{maxWidth: "1000px", margin: "0 auto"}}>
        <PlayerLogin />
        <div className="h-space">
          <div>
            <Space size={32}>
              <Logo/>
              { User.leagues_admin && <a style={{color: 'white', fontWeight: 'bold'}} href="/">Leagues Admin</a> }
              { User.me && <a style={{color: 'white', fontWeight: 'bold'}} href="/tournaments">Tournaments</a> }
              {links}
            </Space>
          </div>
          {gon.user && <Dropdown trigger="click" overlay={menu}>
            <span onClick={(e) => e.preventDefault()} style={{cursor: "pointer"}}>
              <Space>
                {gon.user.name}
                <DownOutlined/>
              </Space>
            </span>
          </Dropdown>}
          {!gon.user && !hideLogin && <div>
            <a style={{color: 'white'}} onClick={() => LoginStore.open('login')}>Login</a>
          </div>}
        </div>
      </div>
    </div>
  </div>
});


